import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { BrowserRouter } from 'react-router-dom';
import { QueryClientProvider } from '@tanstack/react-query';
import {
  onSigninCallback,
  queryClient,
  keycloak,
} from './keycloak/KeycloakConfig';
import { ProtectedApp } from './components/ProtectedApp';
import { ReactKeycloakProvider } from '@react-keycloak/web';
import '@heyform-inc/form-renderer/style.css';
import { initI18n } from '@heyform-inc/form-renderer';

// Initialise i18next with form-renderer's bundled translations.
// Must be called before any FormRenderer mounts.
initI18n();

// Note: React.StrictMode is intentionally omitted — @react-keycloak/web@3.x
// calls keycloak.init() on mount and does not tolerate the double-invoke that
// StrictMode applies in development, producing "instance can only be
// initialized once".  Remove this comment and re-add StrictMode once
// @react-keycloak/web ships a fix or the library is replaced.
ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement,
).render(
  <BrowserRouter basename="/">
    <ReactKeycloakProvider
      authClient={keycloak}
      onTokens={onSigninCallback}
      initOptions={{
        onLoad: 'login-required',
        pkceMethod: 'S256',
        checkLoginIframe: false,
        silentCheckSsoRedirectUri:
          window.location.origin + '/silent-check-sso.html',
      }}
    >
      <QueryClientProvider client={queryClient}>
        <ProtectedApp>
          <App />
        </ProtectedApp>
      </QueryClientProvider>
    </ReactKeycloakProvider>
  </BrowserRouter>,
);
